import * as React from 'react'

import { ReactComponent } from '../../types'

export interface InjectedDialogControlProps {
  open: () => void
  close: () => void
  isOpen: boolean
}

interface DialogControlWrapperProps {
  openOnInit?: boolean
}

function withDialogControls<T> (Component: ReactComponent<T & InjectedDialogControlProps>) {
  return class DialogControlsWrapper extends React.Component<T & DialogControlWrapperProps> {
    public state = {
      isOpen: Boolean(this.props.openOnInit),
    }

    public render () {
      return (
        <Component
          open={this.open}
          close={this.close}
          isOpen={this.state.isOpen}
          {...this.props}
        />
      )
    }

    private open = () => {
      this.setState({ isOpen: true })
    }

    private close = () => {
      this.setState({ isOpen: false })
    }
  }
}

export default withDialogControls



// WEBPACK FOOTER //
// ./src/components/hocs/withDialogControls.tsx